import { Component, forwardRef, TemplateRef, ViewChild } from '@angular/core';
import { FileManagerComponent } from "../file-manager/file-manager.component";
import { EditorModule } from '@tinymce/tinymce-angular';

import 'tinymce/tinymce.min.js';                    
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme.min.js'; 

// საჭიროებისამებრ პლაგინები
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/image';
import 'tinymce/plugins/fullscreen';
// ✅ უფასო (free) პლაგინები — გამოსადეგი ფუნქციები
import 'tinymce/plugins/table';
import 'tinymce/plugins/code';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/quickbars';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-text-editor',
  standalone: true,
  imports: [FileManagerComponent, EditorModule, FormsModule],
  templateUrl: './text-editor.component.html',
  styleUrl: './text-editor.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextEditorComponent),
      multi: true
    }
  ]
})
export class TextEditorComponent {

  @ViewChild('fileManagerModal', { static: true })
  fileManagerModal!: TemplateRef<any>;

  value: string = '';
  modalRef: any;
  filePickerCallback: ((url: string) => void) | null = null;

  constructor(private modalService: NgbModal) {}

  // ✅ ControlValueAccessor
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    this.value = value || '';
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  // ✅ TinyMCE file picker
  openFileManagerWrapper = (callback: any, _value: string, meta: any) => {
    this.filePickerCallback = (url: string) => {
      if (meta?.filetype === 'image') {
        callback(url, { alt: '' });
      } else {
        callback(url, { text: url });
      }
    };

    this.modalRef = this.modalService.open(this.fileManagerModal, {
      size: 'xl',
      fullscreen: true,
      windowClass: 'custom-filemanager-modal',
      backdropClass: 'custom-filemanager-backdrop',
    });
  };

  onFileSelected(url: string) {
    if (this.filePickerCallback) {
      this.filePickerCallback(url);
      this.filePickerCallback = null;
    }

    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}
